import React, { useState, useEffect } from 'react';
import { DocLink } from './DocModal';

const STORAGE_KEY = 'kialuga_cookies_aceites';

export default function CookieBanner() {
  const [visivel, setVisivel] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) {
      setTimeout(() => setVisivel(true), 800);
    }
  }, []);

  const aceitar = () => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ aceite: true, data: new Date().toISOString() }));
    setVisivel(false);
  };

  const apenasNecessarios = () => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ aceite: false, data: new Date().toISOString() }));
    setVisivel(false);
  };

  if (!visivel) return null;

  return (
    <div style={{
      position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 999,
      background: 'rgba(6,14,28,0.97)', borderTop: '1px solid rgba(255,255,255,0.08)',
      padding: '16px 20px',
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      gap: '16px', flexWrap: 'wrap',
      backdropFilter: 'blur(12px)',
      fontFamily: 'Plus Jakarta Sans, sans-serif',
    }}>
      <div style={{ flex: 1, minWidth: '260px', fontSize: '12px', color: 'rgba(255,255,255,0.65)', lineHeight: '1.6' }}>
        🍪 A KiAluga usa cookies essenciais para o funcionamento da plataforma e cookies analíticos para melhorar a experiência. Consulta a nossa{' '}
        <DocLink docKey="cookies">Política de Cookies</DocLink>
        {' '}e a{' '}
        <DocLink docKey="privacidade">Política de Privacidade</DocLink>.
      </div>
      <div style={{ display: 'flex', gap: '8px', flexShrink: 0 }}>
        <button onClick={apenasNecessarios} style={{
          padding: '8px 14px', borderRadius: '8px', fontSize: '12px', fontWeight: '500',
          background: 'transparent', border: '1px solid rgba(255,255,255,0.15)',
          color: 'rgba(255,255,255,0.5)', cursor: 'pointer', fontFamily: 'inherit',
        }}>
          Apenas essenciais
        </button>
        <button onClick={aceitar} style={{
          padding: '8px 16px', borderRadius: '8px', fontSize: '12px', fontWeight: '600',
          background: '#F97316', border: 'none', color: '#fff', cursor: 'pointer',
          fontFamily: 'inherit',
        }}>
          Aceitar todos
        </button>
      </div>
    </div>
  );
}
